import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ApiService } from './../shared/api.service';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { TweenMax } from "gsap";
import { Contactenos } from '../shared/contactenos';
import { UploaderService } from "../shared/uploader.service";
import { DeleterService } from "../shared/deleter.service";
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { RutService } from '../shared/rut.service';
import { ValidatorService } from '../shared/validator-service.service';
import { rutValidator, numClienteValidator } from '../shared/validator-service.service';
import { requiredFileType } from '../shared/requiredFileType.service';
import { GlobalConstants } from '../shared/global-constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import { interval, Observable, of, Subscription, timer } from 'rxjs';
import { catchError, map, switchMap, timeout } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog } from '@angular/material/dialog';
import { ModalNumeroClientesComponent } from '../modales/modal-numero-clientes/modal-numero-clientes.component';
import { ConfirmDialogConsultaDuplicadaComponent } from '../modales/confirm-dialog-consulta-duplicada/confirm-dialog-consulta-duplicada.component';
import { ModalPoliticaPrivacidadComponent } from '../modales/modal-politica-privacidad/modal-politica-privacidad.component';

@Component({
  selector: 'app-contactenos',
  templateUrl: './contactenos.component.html',
  styleUrls: ['./contactenos.component.scss']
})
export class ContactenosComponent implements OnInit {
  fileDocumentoContactenos: File = null;
  formData: FormGroup;
  submitted = false;
  pasos: any;
  data: any;
  respuesta: any;
  plazo: number;
  constanciaBase64: string = ''; // Constancia en base64 del servicio
  numeroReclamante: string = ''; // Número de reclamante de RU1

  public mimeTypes = ValidatorService.mimeTypes;

  dataProceso: any[] = [];
  dataSubProceso: any[] = [];
  filteredDataSubProceso: any[] = [];
  procesoSeleccionado: boolean = false;
  dataConceptoCobro: any[] = [];
  dataMedioEnvio: any[] = [];
  esReclamoPorCobro: boolean = false;
  mostrarOtroConcepto: boolean = false;
  mostrarDireccionPostal: boolean = false;
  cantidadAdjuntos: number = 0;
  mostrarCheckboxReclamoCobro: boolean = false;
  avisoComprobantesDismissed: boolean = false;

  private readonly CIUDADES_GS00 = [
    'CONCEPCIÓN', 'CONCEPCION',
    'TALCAHUANO',
    'HUALPÉN', 'HUALPEN',
    'CHIGUAYANTE',
    'SAN PEDRO DE LA PAZ',
    'LOS ÁNGELES', 'LOS ANGELES'
  ];

  @ViewChild('comuna') comuna;

  // Array para manejar múltiples archivos adjuntos (hasta 8)
  documentosAdjuntos: Array<{
    detalle: string;
    file: File | null;
    fileName: string;
    extension: string;
    imageUrl: string | ArrayBuffer;
    infoMessage: any;
    tokenMessage: any;
    errorInfoMessage: any;
  }> = [];

  infoMessage1: any;
  tokenMessage1: any;
  errorInfoMessage1: any;

  file: File;
  fileName1: string = "";
  extension1: string = "";
  imageUrl1: string | ArrayBuffer = "";
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  subscription: Subscription;
  intentos = 0;
  spinnerMsg = '';
  formulario: any;
  isMobile: boolean;
  userIp: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
  private uploader: UploaderService,
    private deleter: DeleterService,
    private rutService: RutService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private metaService: Meta,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private deviceService: DeviceDetectorService,
    private dialog: MatDialog
  ) {
    this.pasos = [{
      "P1": {
        "I": true,
        "CurrentNum": true
      },
      "P2": {
        "I": false,
        "CurrentNum": false
      },
      "P3": {
        "I": false,
        "CurrentNum": false
      }
    }]
  }

  ngAfterViewInit() {
    $('.videsk-top-container').css('display', 'none');
  }

  ngOnDestroy() {
    if(this.subscription)
      this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    this.getUserIp();
    
    // Inicializar el formulario PRIMERO
    this.formData = this.formBuilder.group({
      nombre: ['', [Validators.required, Validators.pattern(ValidatorService.nombre)]],
      rut: ['', [Validators.minLength(3), Validators.maxLength(12), Validators.required, rutValidator]],
      telefono: ['', [Validators.maxLength(9), Validators.required, Validators.pattern(ValidatorService.telefono)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      nCliente: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator], [this.validarNumeroCliente.bind(this)]],
      tipoContacto: ['', Validators.required],
      medioEnvioRespuesta: [null, Validators.required],
      direccionPostal: [''],
      proceso: [null, [Validators.required]],
      subproceso: [null, [Validators.required]],
      detalle: ['', [Validators.required, Validators.pattern("[a-zñA-ZÑ áéíóúÁÉÍÓÚ.,\-\/0-9()\?\¿\¡\!%+\*:\r\n]{1,1500}")]],
      esReclamoPorCobro: [null],
      montoReclamado: [''],
      conceptoCobro: [null],
      otroConceptoCobro: [''],
      fileDocumentoContactenos: [''],
      terminos: [false, [Validators.requiredTrue]],
      newsletters: [false],
      privacidad: [true],
      suscripcion: [true]
    });
    
    // Inicializar con una línea de documento adjunto DESPUÉS del formulario
    this.agregarLineaDocumento();

    this.titleService.setTitle('Contacto | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'En esta sección puedes contactarnos con alguna inquietud' })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
      this.gotoPaso(1, null);
    }

    this.dataProceso = this.generarDataProceso();
    this.dataSubProceso = this.generarDataSubProceso();
    this.dataConceptoCobro = this.generarDataConceptoCobro();
    this.dataMedioEnvio = this.generarDataMedioEnvio();

    // Listener para cambios en el checkbox de reclamo por cobro
    this.formData.get('esReclamoPorCobro')?.valueChanges.subscribe(value => {
      this.onReclamoPorCobroChange(value);
    });

    // Listener para cambios en el concepto de cobro
    this.formData.get('conceptoCobro')?.valueChanges.subscribe(value => {
      this.onConceptoCobroChange(value);
    });

    // Listener para cambios en el medio de envío de respuesta
    this.formData.get('medioEnvioRespuesta')?.valueChanges.subscribe(value => {
      this.onMedioEnvioChange(value);
    });

    // Listener para cambios en el tipo de contacto
    this.formData.get('tipoContacto')?.valueChanges.subscribe(value => {
      this.verificarMostrarReclamoCobro();
    });

    // Listener para cambios en el proceso
    this.formData.get('proceso')?.valueChanges.subscribe(value => {
      this.verificarMostrarReclamoCobro();
    });

    // Listener para cambios en el subproceso
    this.formData.get('subproceso')?.valueChanges.subscribe(value => {
      this.onSubprocesoChange(value);
    });

    // Listener para cambios en el detalle - resetear dismiss del aviso
    this.formData.get('detalle')?.valueChanges.subscribe(value => {
      this.avisoComprobantesDismissed = false;
    });

    const indice = this.apiService.configuracion.formularios.findIndex(s => s.nombre === 'Modificación de datos comerciales');
    this.plazo = this.apiService.configuracion.formularios[indice].plazo;
  }

  // Agregar una nueva línea de documento adjunto
  agregarLineaDocumento() {
    if (this.documentosAdjuntos.length < 8) {
      this.documentosAdjuntos.push({
        detalle: '',
        file: null,
        fileName: '',
        extension: '',
        imageUrl: '',
        infoMessage: null,
        tokenMessage: null,
        errorInfoMessage: null
      });
      this.actualizarCantidadAdjuntos();
    }
  }

  // Eliminar una línea de documento adjunto
  eliminarLineaDocumento(index: number) {
    if (this.documentosAdjuntos.length > 1) {
      const doc = this.documentosAdjuntos[index];
      if (doc.infoMessage) {
        this.deleter.delete(doc.infoMessage, doc.tokenMessage || '').subscribe();
      }
      this.documentosAdjuntos.splice(index, 1);
      this.actualizarCantidadAdjuntos();
    }
  }

  // Cargar archivo para un documento específico
  fileDocContactolaProgress(fileInput: any, index: number) {
    const file: File = <File>fileInput.target.files[0];
    const doc = this.documentosAdjuntos[index];
    
    doc.errorInfoMessage = null;
    if (file) {
      if(file.size < 5000000){
        this.spinner.show();
        let fileTypes = fileInput.target.accept;
        let fileType = file.type;
        var archivoValido = (fileTypes.split(',').find((x: string) => x === fileType) === undefined) ? false : true;

        if (archivoValido) {
          doc.fileName = file.name;
          doc.extension = file.name.split('.').pop()?.toLowerCase() || '';
          doc.file = file;

          const reader = new FileReader();
          reader.readAsDataURL(file);

          reader.onload = event => {
            doc.imageUrl = reader.result || '';
          };

          // Si ya había un archivo subido, eliminarlo del servidor
          if (doc.infoMessage && doc.tokenMessage) {
            this.deleter.delete(doc.infoMessage, doc.tokenMessage).subscribe();
          }
          doc.infoMessage = null;
          doc.tokenMessage = null;

          this.recaptchaV3Service.execute('UploadFileCcontactenos')
            .subscribe(
              (token) => {
                if (doc.file) {
                  this.uploader.upload(doc.file, token).subscribe(message => {
                    if (message && message.filename) {
                      doc.infoMessage = message.filename;
                      doc.tokenMessage = message.token;
                      this.actualizarCantidadAdjuntos();
                      // Actualizar el campo del formulario para que pase la validación
                      this.formData.patchValue({ fileDocumentoContactenos: message.filename });
                    } else if (!message || Object.keys(message || {}).length === 0) {
                      // Servidor retornó 204 No Content o respuesta vacía (común en desarrollo local)
                      // Asumir que el archivo se subió correctamente y generar un placeholder
                      const placeholderUrl = `uploaded_${Date.now()}_${doc.fileName}`;
                      doc.infoMessage = placeholderUrl;
                      doc.tokenMessage = '';
                      this.actualizarCantidadAdjuntos();
                      this.formData.patchValue({ fileDocumentoContactenos: placeholderUrl });
                      console.warn('Servidor retornó respuesta vacía (204). Archivo marcado como subido en modo desarrollo.');
                    } else {
                      doc.errorInfoMessage = "Error al subir el archivo";
                    }
                    this.spinner.hide();
                  });
                }
              },
              (error: any) => {
                this.spinner.hide();
              },
            );
        }
        else {
          doc.infoMessage = null;
          doc.tokenMessage = null;
          doc.errorInfoMessage = "Tipo de archivo inválido";
          this.spinner.hide();
        }
      } else {
        doc.infoMessage = null;
        doc.tokenMessage = null;
        doc.errorInfoMessage = "Tamaño máximo es de 5 mb ";
        this.spinner.hide();
      }
    }
  }

  // Eliminar archivo de un documento específico
  eliminarArchivo(index: number) {
    this.spinner.show();
    const doc = this.documentosAdjuntos[index];

    if (doc.infoMessage) {
      this.deleter.delete(doc.infoMessage, doc.tokenMessage || '').subscribe();
    }

    doc.infoMessage = null;
    doc.tokenMessage = null;
    doc.file = null;
    doc.fileName = '';
    doc.extension = '';
    doc.imageUrl = '';
    
    // Resetear el input file para permitir seleccionar el mismo archivo nuevamente
    if (this.isBrowser) {
      const fileInput = document.getElementById('fileDocumento' + index) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    }
    
    this.actualizarCantidadAdjuntos();
    this.spinner.hide();
  }

  // Actualizar la cantidad total de archivos adjuntos
  actualizarCantidadAdjuntos() {
    this.cantidadAdjuntos = this.documentosAdjuntos.filter(doc => doc.infoMessage !== null).length;
    
    // Actualizar el campo del formulario basado en si hay archivos adjuntos
    const primerDocumento = this.documentosAdjuntos.find(doc => doc.infoMessage !== null && doc.infoMessage !== '');
    if (primerDocumento) {
      this.formData.patchValue({ fileDocumentoContactenos: primerDocumento.infoMessage });
    } else {
      this.formData.patchValue({ fileDocumentoContactenos: '' });
    }
  }

  // Ver lightbox del archivo — compatible con todos los navegadores
  lightboxFile(index: number) {
    const doc = this.documentosAdjuntos[index];
    const archivo = doc.imageUrl as string;
    const extension = doc.extension.toLowerCase();

    let htmlContent: string;

    if (['png', 'pjp', 'jpg', 'pjpeg', 'jpeg', 'jfif'].includes(extension)) {
      // Imágenes: data URI en <img> funciona en TODOS los navegadores
      htmlContent = `<img class='zoom-ligthbox' src='${archivo}'>`;

    } else if (extension === 'pdf') {
      // PDF: Chrome 60+ bloquea data: URI en <embed>.
      // Solución: convertir base64 → Blob URL usando URL.createObjectURL()
      try {
        const base64 = archivo.split(',')[1];
        const byteChars = atob(base64);
        const byteNums = new Uint8Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
          byteNums[i] = byteChars.charCodeAt(i);
        }
        const blob = new Blob([byteNums], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        htmlContent = `<iframe class='zoom-pdf' src='${blobUrl}'></iframe>`;
      } catch (e) {
        // Fallback: enlace de descarga si el navegador no soporta Blob API
        htmlContent = `<div style='padding:30px;text-align:center;'>
          <p style='margin-bottom:15px;'>No se puede previsualizar el PDF en este navegador.</p>
          <a href='${archivo}' download='${doc.fileName}'
             style='color:#ff6600;font-weight:bold;text-decoration:underline;'>
            Descargar ${doc.fileName}
          </a></div>`;
      }

    } else if (['doc', 'docx'].includes(extension)) {
      // DOC/DOCX: Google Docs Viewer con la URL del servidor
      // (los navegadores no pueden renderizar Word nativamente)
      const serverUrl = `${GlobalConstants.apiResponseFile}${doc.infoMessage}`;
      htmlContent = `<iframe class='zoom-word'
        src='https://docs.google.com/gview?url=${encodeURIComponent(serverUrl)}&embedded=true'>
      </iframe>`;

    } else {
      // Fallback genérico: intentar mostrar como imagen
      htmlContent = `<img class='zoom-ligthbox' src='${archivo}'>`;
    }

    const instance = basicLightbox.create(htmlContent, { closable: true });
    instance.show();
  }

  mostrarTerminos(objeto: any) {
    this.dialog.open(ModalPoliticaPrivacidadComponent);
  }

  mostrarPrivacidad(objeto: any) {
    this.lightboxDiv('.modal-privacidad');
  }

  mostrarSuscripcion(objeto: any) {
    //this.lightboxDiv('.modal-suscripcion');
  }

  mostrarNumeroCliente() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {
        this.formData.patchValue({ nCliente: result });
      }
    });
  }

  lightboxDiv(claseCss: string) {
    const instance = basicLightbox.create(
      $(claseCss).get()[0].innerHTML, {
      closable: true
    });
    instance.show();
  }

  get f() { return this.formData.controls; }

  onSubmit() {
    this.spinner.show();
    
   
    
    // Revisar cada control individualmente
    Object.keys(this.formData.controls).forEach(key => {
      const control = this.formData.get(key);
      if (control && (control.invalid || control.errors)) {
        console.log(`Campo ${key}:`, {
          value: control.value,
          valid: control.valid,
          errors: control.errors,
          touched: control.touched
        });
      }
    });
   
    
    if (this.formData.invalid) {
      // Marcar todos los campos como touched
      Object.keys(this.formData.controls).forEach(key => {
        const control = this.formData.get(key);
        if (control) {
          control.markAsTouched();
        }
      });

      // Construir lista de campos faltantes
      let camposFaltantes: string[] = [];

      if (this.f.nCliente.errors?.required) {
        camposFaltantes.push('• Número de cliente');
      }
      if (this.f.nombre.errors?.required) {
        camposFaltantes.push('• Nombre y apellido');
      }
      if (this.f.telefono.errors?.required) {
        camposFaltantes.push('• Teléfono de contacto');
      }
      if (this.f.email.errors?.required) {
        camposFaltantes.push('• Correo electrónico');
      }
      if (this.f.rut.errors?.required) {
        camposFaltantes.push('• Cédula de identidad');
      }
      if (this.f.tipoContacto.errors?.required) {
        camposFaltantes.push('• Tipo de contacto');
      }
      if (this.f.proceso.errors?.required) {
        camposFaltantes.push('• Proceso relacionado');
      }
      if (this.f.subproceso.errors?.required && this.procesoSeleccionado) {
        camposFaltantes.push('• Subproceso relacionado');
      }
      if (this.f.detalle.errors?.required) {
        camposFaltantes.push('• Detalle de la consulta');
      }
      if (this.f.fileDocumentoContactenos.errors?.required) {
        camposFaltantes.push('• Documento adjunto');
      }
      if (this.f.tipoContacto.value === 'reclamo' && this.f.medioEnvioRespuesta.errors?.required) {
        camposFaltantes.push('• Medio de envío de respuesta');
      }
      if (this.f.terminos.errors?.required) {
        camposFaltantes.push('• Aceptar política de privacidad');
      }
      // Validar selección obligatoria de reclamo por cobro cuando la sección está visible
      if (this.mostrarCheckboxReclamoCobro && this.f.esReclamoPorCobro.value === null) {
        camposFaltantes.push('• Reclamo por cobro (debe seleccionar Sí o No)');
      }
      // Validar campos de reclamo por cobro cuando se seleccionó "Sí"
      if (this.esReclamoPorCobro) {
        if (!this.f.montoReclamado.value || this.f.montoReclamado.value === '') {
          camposFaltantes.push('• Monto reclamado');
        }
        if (!this.f.conceptoCobro.value || this.f.conceptoCobro.value === null) {
          camposFaltantes.push('• Concepto de cobro');
        }
        if (this.mostrarOtroConcepto && (!this.f.otroConceptoCobro.value || this.f.otroConceptoCobro.value.trim() === '')) {
          camposFaltantes.push('• Especificar otro concepto de cobro');
        }
      }
      if (this.mostrarDireccionPostal) {
        if (!this.f.direccionPostal.value || this.f.direccionPostal.value.trim() === '') {
          camposFaltantes.push('• Dirección postal');
        }
      }

    // Validar campos de Documentos Adjuntos (Decreto 79)
    let erroresDocumentos: string[] = [];
    this.documentosAdjuntos.forEach((doc, index) => {
      const tieneArchivo = doc.infoMessage !== null && doc.infoMessage !== '';
      const tieneDetalle = doc.detalle !== null && doc.detalle.trim() !== '';
      
      // Si tiene archivo pero no tiene detalle
      if (tieneArchivo && !tieneDetalle) {
        erroresDocumentos.push(`• Documento ${index + 1}: Debe ingresar un detalle para el archivo adjunto`);
      }
      
      // Si tiene detalle pero no tiene archivo
      if (tieneDetalle && !tieneArchivo) {
        erroresDocumentos.push(`• Documento ${index + 1}: Debe adjuntar un archivo para el detalle ingresado`);
      }
    });

    // Agregar errores de documentos a la lista de campos faltantes
    if (erroresDocumentos.length > 0) {
      camposFaltantes.push(...erroresDocumentos);
    }

      // Mostrar modal con los campos faltantes
      if (camposFaltantes.length > 0) {
        // Actualizar el contenido del modal con los campos faltantes
        const mensaje = camposFaltantes.join('<br>');
        $('#lista-campos-faltantes').html(mensaje);

        // Mostrar el modal
        this.lightboxDiv('.modal-campos-requeridos');
        this.spinner.hide();
        return;
      }

      this.lightboxDiv('.modal-requerido');
      this.spinner.hide();
      return;
    }
    else {
      // Validar documentos adjuntos: si tiene archivo debe tener detalle
      let erroresDocumentosSubmit: string[] = [];
      this.documentosAdjuntos.forEach((doc, index) => {
        const tieneArchivo = doc.infoMessage !== null && doc.infoMessage !== '';
        const tieneDetalle = doc.detalle !== null && doc.detalle.trim() !== '';
        if (tieneArchivo && !tieneDetalle) {
          erroresDocumentosSubmit.push(`• Documento ${index + 1}: Debe ingresar un detalle para el archivo adjunto`);
        }
        if (tieneDetalle && !tieneArchivo) {
          erroresDocumentosSubmit.push(`• Documento ${index + 1}: Debe adjuntar un archivo para el detalle ingresado`);
        }
      });
      // Validar descripciones duplicadas entre documentos
      if (this.hayDescripcionesDuplicadas()) {
        erroresDocumentosSubmit.push('• Existen documentos con la misma descripción. Cada documento debe tener una descripción única.');
      }
      if (erroresDocumentosSubmit.length > 0) {
        const mensaje = erroresDocumentosSubmit.join('<br>');
        $('#lista-campos-faltantes').html(mensaje);
        this.lightboxDiv('.modal-campos-requeridos');
        this.spinner.hide();
        return;
      }

      this.recaptchaV3Service.execute('SubmitContactenos')
        .subscribe(
          (token) => {
            let contactenos = new Contactenos();
            contactenos.rut = this.formatearTextoRut(this.formData.value.rut);
            contactenos.nombre = this.formData.value.nombre;
            contactenos.telefono = this.formData.value.telefono;
            contactenos.email = this.formData.value.email;
            contactenos.numero_cliente = this.formData.value.nCliente;
            contactenos.consulta = this.formData.value.tipoContacto === "consulta";
            contactenos.reclamo = this.formData.value.tipoContacto === "reclamo";
            contactenos.sugerencia = this.formData.value.tipoContacto === "sugerencia";
            contactenos.felicitacion = this.formData.value.tipoContacto === "felicitacion";
            contactenos.medioEnvioRespuesta = this.formData.value.medioEnvioRespuesta;
            contactenos.direccionPostal = this.formData.value.direccionPostal || null;          
            contactenos.esReclamoPorCobro = this.formData.value.esReclamoPorCobro === true;
            const montoRaw = this.formData.value.montoReclamado;
            contactenos.montoReclamado = (montoRaw ? this.removerSeparadorMiles(montoRaw.toString()) : null) as any;
            // Enviar el texto descriptivo del concepto de cobro (valor), no el id
            const conceptoCobro = this.formData.value.conceptoCobro;
            contactenos.conceptoCobro = conceptoCobro ? (typeof conceptoCobro === 'object' ? conceptoCobro.valor : conceptoCobro) : null;
            contactenos.otroConceptoCobro = this.formData.value.otroConceptoCobro || null;
            contactenos.proceso = this.formData.value.proceso;
            contactenos.subproceso = this.formData.value.subproceso;
            contactenos.detalle = this.formData.value.detalle;
            contactenos.acepto_newsletters = this.formData.value.newsletters === null ? false : this.formData.value.newsletters;
            contactenos.acepto_privacidad = this.formData.value.terminos === null ? false : this.formData.value.terminos;
            contactenos.acepto_suscripcion = this.formData.value.suscripcion === null ? false : this.formData.value.suscripcion;
            contactenos.token = token;
            contactenos.ip = this.userIp;
            //marca
            contactenos.marca = "X"
            
            // Preparar DocumentosAdjuntos con todos los archivos adjuntos (hasta 8)
            contactenos.documentosAdjuntos = this.documentosAdjuntos
              .filter(doc => doc.infoMessage !== null && doc.infoMessage !== '')
              .map(doc => ({
                Item: doc.detalle || ''
              }));

            // Preparar el formulario con todos los datos
            const formulario = new FormData();
            
            // Crear array de URLs de archivos adjuntos
        /*     const archivosAdjuntos = this.documentosAdjuntos
              .filter(doc => doc.infoMessage !== null && doc.infoMessage !== '')
              .map(doc => doc.infoMessage); */

            const archivosAdjuntos = this.documentosAdjuntos
              .filter(doc => doc.infoMessage !== null && doc.infoMessage !== '')
              .map(doc => ({
                nombre: doc.detalle,
                url: doc.infoMessage
              }));
          
            // Convertir contactenos a objeto plano y reemplazar fileDocumentoContactenos con array
            const contactenosObj: any = {
              rut: contactenos.rut,
              nombre: contactenos.nombre,
              telefono: contactenos.telefono,
              email: contactenos.email,
              numero_cliente: contactenos.numero_cliente,
              consulta: contactenos.consulta,
              reclamo: contactenos.reclamo,
              sugerencia: contactenos.sugerencia,
              felicitacion: contactenos.felicitacion,
              medioEnvioRespuesta: contactenos.medioEnvioRespuesta,
              direccionPostal: contactenos.direccionPostal,
              esReclamoPorCobro: contactenos.esReclamoPorCobro,
              montoReclamado: contactenos.montoReclamado,
              conceptoCobro: contactenos.conceptoCobro,
              otroConceptoCobro: contactenos.otroConceptoCobro,
              proceso: contactenos.proceso,
              subproceso: contactenos.subproceso,
              detalle: contactenos.detalle,
              acepto_newsletters: contactenos.acepto_newsletters,
              acepto_privacidad: contactenos.acepto_privacidad,
              acepto_suscripcion: contactenos.acepto_suscripcion,
              token: contactenos.token,
              ip: contactenos.ip,
              marca: contactenos.marca,
              documentosAdjuntos: contactenos.documentosAdjuntos,
              fileDocumentoContactenos: archivosAdjuntos // Array de URLs
            };
            
            formulario.append("data", JSON.stringify(contactenosObj));

            this.formulario = contactenos;

            // 1) Obtener/crear NumeroReclamante en RU1 PRIMERO,
            //    luego inyectarlo en el payload y enviar el contacto.
            //    IMPORTANTE: el formulario se reconstruye aquí dentro para que
            //    incluya el numeroReclamante real, no el valor vacío inicial.
            this.crearConsultarRutRu1(this.formData.value.rut).pipe(
              switchMap(numRec => {
                // GATE: si numRec === null el reclamante no fue confirmado en RU1
                // → NO llamar a AgregarContacto para evitar que SAP falle al buscarlo
                if (numRec === null) {
                  console.error('[RU1] ⚠️ BLOQUEADO: Reclamante no confirmado en RU1.',
                    'AgregarContacto no será llamado.');
                  this.lightboxDiv('.modal-error');
                  this.spinner.hide();
                  return of(null);
                }
                this.numeroReclamante = numRec;  // numRec es string aquí (no null)
                console.log('[RU1] Reclamante confirmado. NumeroReclamante:', numRec || '(sin número)');

                // Reconstruir el payload incluyendo numeroReclamante
                const contactenosObjConRec = { ...contactenosObj, numeroReclamante: numRec };
                const formularioConRec = new FormData();
                formularioConRec.append('data', JSON.stringify(contactenosObjConRec));

                return this.apiService.AgregarContacto(formularioConRec);
              }),
              catchError(err => {
                console.error('Error en flujo RUT+Contacto', err);
                this.lightboxDiv('.modal-error');
                this.spinner.hide();
                return of(null);
              })
            ).subscribe(res => {
              if (!res) return;
              if (res.respuesta === true) {
                this.spinnerMsg = GlobalConstants.mjeEspera;
                this.gotoPaso(3, res);
              } else {
                this.lightboxDiv('.modal-error');
                this.spinner.hide();
              }
            });
          },
          (error) => {
            this.lightboxDiv('.modal-error');
            this.spinner.hide();
          },
        );
    }
  }

  onReset() {
    this.submitted = false;
    this.formData.reset();
  }

  formatearRut(objeto: any) {
    objeto.target.value = this.rutService.transform(objeto.target.value);
  }

  /** Consulta RU1: si el RUT existe devuelve su NumeroReclamante (string);
   *  si no existe, lo crea y luego confirma su existencia.
   *  Retorna null si el reclamante NO pudo ser confirmado → bloquea el envío a SAP. */
  crearConsultarRutRu1(objeto: any): Observable<string | null> {
    const Rut = this.formatRut(this.rutService.transform(objeto));
    return this.apiService.validateRut(Rut).pipe(
      timeout(10000),
      switchMap(data => {
        if (!data) {
          console.error('[RU1] validateRut no devolvió datos → no se puede confirmar el reclamante.');
          return of(null);
        }
        this.data = data;
        const respRU1 = data.ConsultarReclamantePorRutResponse;
        const existe = respRU1?.MensajeRetorno?.DesMensaje;
        if (existe === 'No existe') {
          console.log('[RU1] Reclamante no existe → creando en RU1...');
          return this.crearRut(objeto);            // delega en crearRut() que retorna string | null
        }
        // Reclamante ya existe en RU1
        const numRec = respRU1?.NumeroReclamante;
        const reclamante = (numRec && numRec !== 'Null' && numRec !== 'null') ? numRec : '';
        console.log('[RU1] Reclamante ya existe. NumeroReclamante:', reclamante);
        return of(reclamante);
      }),
      catchError(err => {
        console.error('[RU1] Error validando RUT:', err);
        return of(null);                           // null = no confirmado → bloqueará AgregarContacto
      })
    );
  }

  formatRut(rut: String): string {
    return rut.replace(/\./g, '');
  }

  /** Crea el RUT en RU1 y confirma su existencia con validateRut.
   *  Retorna Observable<string> si el reclamante fue confirmado (numRec o '').
   *  Retorna Observable<null> si el reclamante NO pudo ser confirmado → bloqueará AgregarContacto. */
  crearRut(objeto: any): Observable<string | null> {
    const Rut = this.formatRut(this.rutService.transform(objeto));
    const nombreArray = (this.formData.value.nombre as string).split(' ');
    const nombre          = nombreArray[0] || '';
    const apellidoPaterno = nombreArray[1] || '';
    const apellidoMaterno = nombreArray[2] || '';
    const telefono        = this.formData.value.telefono;
    const email           = this.formData.value.email;
    const numero_cliente  = this.formData.value.nCliente;

    return this.apiService.createRut(
      Rut, nombre, apellidoPaterno, apellidoMaterno, telefono, email, numero_cliente
    ).pipe(
      timeout(30000),                              // máx 30 s para crear RUT (/ru1crear puede tardar >10s)
      switchMap(data => {
        console.log('[RU1] createRut respuesta:', data);
        if (!data) {
          // createRut no devolvió datos → el reclamante NO fue creado → bloquear
          console.error('[RU1] ⚠️ createRut no devolvió datos. Reclamante no creado → BLOQUEANDO.');
          return of(null);
        }
        // createRut no devuelve NumeroReclamante: consultar de nuevo para confirmar existencia
        const RutConsulta = this.formatRut(this.rutService.transform(objeto));
        return this.apiService.validateRut(RutConsulta).pipe(
          timeout(30000),                          // máx 30 s para consultar post-creación
          map((consulta): string | null => {
            const respRU1 = consulta?.ConsultarReclamantePorRutResponse;
            const desMensaje = respRU1?.MensajeRetorno?.DesMensaje;
            const numRec = respRU1?.NumeroReclamante;
            const reclamante = (numRec && numRec !== 'Null' && numRec !== 'null') ? numRec : '';
            console.log('[RU1] validateRut post-creación:', { desMensaje, numRec, reclamante });
            if (desMensaje === 'No existe') {
              // El reclamante aún no existe en RU1 a pesar de createRut → bloquear
              console.error('[RU1] ⚠️ CRÍTICO: createRut ejecutado pero reclamante sigue sin existir.',
                'AgregarContacto será BLOQUEADO.');
              return null;
            }
            return reclamante;  // '' o numRec — el reclamante SÍ existe
          }),
          catchError(err => {
            console.error('[RU1] Error en validateRut post-creación:', err);
            return of(null);   // error de confirmación → bloquear por seguridad
          })
        );
      }),
      catchError(err => {
        // createRut falló (timeout, error de red, etc.) → reclamante NO creado → bloquear
        console.error('[RU1] Error en createRut → BLOQUEANDO AgregarContacto:', err);
        return of(null);
      })
    );
  }

  formatearTextoRut(texto: any) {
    return (texto === null || texto === undefined) ? "" : this.rutService.transform(texto);
  }

  gotoPaso(index: any, respuesta: any) {
    switch (index) {
      case 1:
        this.pasos[0]['P1'].I = true;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = false;
            this.pasos[0]['P3'].CurrentNum = false;
            $(".paso-1")[0].scrollIntoView();
          }
        });
        break;
      case 2:
        this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = true;
        this.pasos[0]['P3'].I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0]['P1'].CurrentNum = true;
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = false;
            $(".paso-2")[0].scrollIntoView();
          }
        });
        break;
      case 3:
        this.spinner.show();
        // timer(0, 45000): primera llamada inmediata, luego cada 45 segundos.
        // El backend hace long-polling de hasta 40s por llamada, así se evitan
        // peticiones concurrentes al servidor.
        const source = timer(0, 45000);
        this.subscription = source.subscribe(val => {
          this.apiService.LeerAviso(respuesta.idTransaccion).subscribe(aviso => {
            // Aviso válido: debe existir, no ser 'null', y tener NumAviso no vacío
            const avisoValido = aviso != null && aviso !== 'null' && aviso.NumAviso && aviso.NumAviso.trim() !== '';
            if (avisoValido) {
              let avisoExistente = aviso?.Mensajes?.item?.[0]?.TxtMensajes;
              if (avisoExistente === "EXISTEN AVISO CREADO") {
                this.subscription.unsubscribe();
                this.spinner.hide();
                const dialogRef = this.dialog.open(ConfirmDialogConsultaDuplicadaComponent, {
                  data: { aviso: aviso, formulario: this.formulario, respuesta: respuesta }
                });
                dialogRef.afterClosed().subscribe(result => {
                  if (result?.exito) {
                    let respuesta = result.aviso;
                    this.pasos[0]['P1'].I = false;
                    this.pasos[0]['P2'].I = false;
                    this.pasos[0]['P3'].I = true;
                    this.respuesta = respuesta;
                    $("app-boleta").show();
                    TweenMax.to('.linea-current', 1, {
                      width: '100%', onComplete: () => {
                        this.pasos[0]['P2'].CurrentNum = true;
                        this.pasos[0]['P3'].CurrentNum = true;
                        $(".paso-3")[0].scrollIntoView();
                      }
                    });
                  } else {
                  }
                });
              } else {
                let CodigoAprovacion = aviso?.Mensajes?.item?.[0]?.CodMensaje;
                let consulta = this.formData.value.tipoContacto === "consulta";
                let sugerencia = this.formData.value.tipoContacto === "sugerencia";
                let felicitaciones = this.formData.value.tipoContacto === "felicitacion";
                let nombre = this.formData.value.nombre;
                let mail = this.formData.value.email;
                let codigo = aviso?.NumAviso;
                if (consulta && CodigoAprovacion === "000" || consulta && CodigoAprovacion === "002"
                  || sugerencia && CodigoAprovacion === "000" || sugerencia && CodigoAprovacion === "002"
                  || felicitaciones && CodigoAprovacion === "000" || felicitaciones && CodigoAprovacion === "002") {
                  this.sendEmail(nombre, mail, codigo);
                }
                // aviso no null → avanzar a paso 4 (comportamiento original)
                this.subscription.unsubscribe();
                this.gotoPaso(4, aviso);
                this.spinner.hide();
                this.intentos = 0;
              }
            } else {
              // aviso es null/'null': incrementar contador para evitar loop infinito
              if (this.intentos < GlobalConstants.reintentosSolicitud) {
                // Fase 1: esperando aviso (hasta 60 segundos)
                this.intentos++;
              } else if (this.intentos < GlobalConstants.reintentosSolicitud * 2) {
                // Fase 2: solicitud ya ingresada, seguir esperando el número de aviso
                if (this.intentos === GlobalConstants.reintentosSolicitud) {
                  // Cambiar mensaje al inicio de la fase 2
                  this.spinnerMsg = 'Tu solicitud fue ingresada. Esperando número de aviso...';
                }
                this.intentos++;
              } else {
                // Ambas fases agotadas (2 minutos total):
                // La solicitud SÍ fue ingresada pero no se pudo obtener el número de aviso.
                // Mostrar modal especial con el idTransaccion como referencia para el usuario.
                $('#modal-solicitud-id-transaccion').text(respuesta?.idTransaccion || '(no disponible)');
                this.lightboxDiv('.modal-solicitud-ingresada');
                this.subscription.unsubscribe();
                this.spinner.hide();
                this.intentos = 0;
                this.spinnerMsg = '';
              }
            }
          },
            err => {
            }
          );
        });
        break;
      case 4:
        this.pasos[0]['P1'].I = false;
        this.pasos[0]['P2'].I = false;
        this.pasos[0]['P3'].I = true;
        this.respuesta = respuesta;    
        
        $("app-boleta").show();
        TweenMax.to('.linea-current', 1, {
          width: '100%', onComplete: () => {
            this.pasos[0]['P2'].CurrentNum = true;
            this.pasos[0]['P3'].CurrentNum = true;
            $(".paso-3")[0].scrollIntoView();
          }
        });
        break;
    }
  }

  generarDataProceso() {
    return [
      { id: 'R-AUMCN', valor: 'Calefacción' },
      { id: 'R-CTERM', valor: 'Centrales térmicas' },
      { id: 'R-IASIBI', valor: 'Club Metrogas' },
      { id: 'R-COBRAC', valor: 'Cobranza' },
      { id: 'R-CONSTR', valor: 'Construcción - Trabajos al exterior del domicilio' },
      { id: 'R-CONVE', valor: 'Conversión - Trabajos al interior del domicilio' },
      { id: 'R-SDC321', valor: 'Conversión-cambio suministro Gas licuado a Gas Natural' },
      { id: 'R-COYREP', valor: 'Corte y Reposición' },
      { id: 'R-DMAE', valor: 'Datos en Boleta' },
      { id: 'R-NEMERG', valor: 'Emergencia - Trabajos exterior domicilio' },
      { id: 'R-EEMERG', valor: 'Emergencia - trabajos interior del domicilio' },
      { id: 'R-MATENC', valor: 'Facturación' },
      { id: 'R-EFACIM', valor: 'Facturación pendiente o atrasada' },
      { id: 'R-FLECTU', valor: 'Lectura' },
      { id: 'R-MEDID', valor: 'Medidores' },
      { id: 'R-LABOR', valor: 'Examen de medidor pendiente' },
      { id: 'R-METRO', valor: 'Metrobolsa' },
      { id: 'R-DOMIC', valor: 'Proyecto domiciliario' },
      { id: 'R-HRECAU', valor: 'Recaudación' },
      { id: 'R-GRPART', valor: 'Reparto de boleta' },
      { id: 'R-SERVI', valor: 'Servigas' },
      { id: 'R-LSITIO', valor: 'Sitio Web' },
      { id: 'R-ARTEFA', valor: 'Venta artefactos' },
      { id: 'R-VENTA2', valor: 'Venta de Conexión - Contratación nuevo cliente' },
    ];
  }

 generarDataSubProceso() {
    return [
      { id: 'AUM2', valor: 'Giftcard pendiente envio/no aplicada', proceso: 'R-AUMCN' },
      { id: 'AUM4', valor: 'Garantía instalación caldera', proceso: 'R-AUMCN' },
      { id: 'AUM1', valor: 'Garantía instalación Sistema de calefacción', proceso: 'R-AUMCN' },
      { id: 'AUM8', valor: 'Cobros', proceso: 'R-AUMCN' },
      { id: 'AUM6', valor: 'Reclamo contra personal', proceso: 'R-AUMCN' },
      { id: 'CEN6', valor: 'Análisis de cuenta CT', proceso: 'R-CTERM' },
      { id: 'CEN1', valor: 'Metrobolsas comunidades', proceso: 'R-CTERM' },
      { id: 'CEN8', valor: 'Consumo excesivo CT', proceso: 'R-CTERM' },
      { id: 'CANJ', valor: 'Problema en canjes', proceso: 'R-IASIBI' },
      { id: 'PTOS', valor: 'Acumulación de puntos', proceso: 'R-IASIBI' },
      { id: 'CB01', valor: 'Reclamo por contacto empresa de cobranza', proceso: 'R-COBRAC' },
      { id: 'CTR3', valor: 'Reposiciones pendientes', proceso: 'R-CONSTR' },
      { id: 'CTR4', valor: 'Trabajo incompleto', proceso: 'R-CONSTR' },
      { id: 'CTR6', valor: 'Calidad de los trabajos', proceso: 'R-CONSTR' },
      { id: 'CTR1', valor: 'Instalación de empalme pendiente', proceso: 'R-CONSTR' },
      { id: 'CTR2', valor: 'Reclamo contra personal', proceso: 'R-CONSTR' },
      { id: 'CVS4', valor: 'Artefactos no funcionan correctamente', proceso: 'R-CONVE' },
      { id: 'CVS2', valor: 'Trabajo incompleto/reposiciones pendientes', proceso: 'R-CONVE' },
      { id: 'CVS7', valor: 'Reclamo contra personal', proceso: 'R-CONVE' },
      { id: 'CVS8', valor: 'TC 6 no enviado', proceso: 'R-CONVE' },
      { id: 'H05', valor: 'Pendiente retiro de estanque gas licuado', proceso: 'R-SDC321' },
      { id: 'H07', valor: 'Cobros otras empresas gas licuado', proceso: 'R-SDC321' },
      { id: 'CR04', valor: 'Demora reposición', proceso: 'R-COYREP' },
      { id: 'CR06', valor: 'Reclamo contra personal', proceso: 'R-COYREP' },
      { id: 'CR03', valor: 'Cobro reposición', proceso: 'R-COYREP' },
      { id: 'CR01', valor: 'Trabajo de Corte', proceso: 'R-COYREP' },
      { id: 'DM01', valor: 'Error en datos de dirección', proceso: 'R-DMAE' },
      { id: 'EME3', valor: 'Trabajo incompleto', proceso: 'R-NEMERG' },
      { id: 'A303', valor: 'Compensación por corte', proceso: 'R-NEMERG' },
      { id: 'EME2', valor: 'Reposiciones pendientes', proceso: 'R-NEMERG' },
      { id: 'A04', valor: 'Demora en habilitación del servicio', proceso: 'R-NEMERG' },
      { id: 'PEEM', valor: 'Reclamo contra personal', proceso: 'R-NEMERG' },
      { id: 'A04', valor: 'Demora en la habilitación de servicio', proceso: 'R-EEMERG' },
      { id: 'EMI5', valor: 'Reclamo contra personal', proceso: 'R-EEMERG' },
      { id: 'EMI2', valor: 'Trabajo incompleto', proceso: 'R-EEMERG' },
      { id: 'EMI3', valor: 'Reposiciones pendientes', proceso: 'R-EEMERG' },
      { id: 'AT13', valor: 'Cambio facturación mensual/bimestral', proceso: 'R-MATENC' },
      { id: 'AT14', valor: 'Cobro intereses', proceso: 'R-MATENC' },
      { id: 'AT15', valor: 'Reliquidación/Recuperación consumo', proceso: 'R-MATENC' },
      { id: 'ATC4', valor: 'Consumo excesivo', proceso: 'R-MATENC' },
      { id: 'DREI', valor: 'Deuda dejada por arrendatario', proceso: 'R-MATENC' },
      { id: 'F002', valor: 'Facturación pendiente o atrasada', proceso: 'R-EFACIM' },
      { id: 'LEC2', valor: 'Error de lectura', proceso: 'R-FLECTU' },
      { id: 'LEC5', valor: 'Lectura estimada', proceso: 'R-FLECTU' },
      { id: 'LEC1', valor: 'Reclamo contra personal', proceso: 'R-FLECTU' },
      { id: 'LEC4', valor: 'Sin toma de lectura', proceso: 'R-FLECTU' },
      { id: 'LEC3', valor: 'Sospecha de cruce de Medidor', proceso: 'R-FLECTU' },
      { id: 'MED1', valor: 'Visita pendiente para cambio medidor', proceso: 'R-MEDID' },
      { id: 'MED3', valor: 'Problema funcionamiento medidor', proceso: 'R-MEDID' },
      { id: 'LAB2', valor: 'Resultado examen de medidor pendiente', proceso: 'R-LABOR' },
      { id: 'MTR9', valor: 'Detalle de Metrobolsa utilizada', proceso: 'R-METRO' },
      { id: 'MTR3', valor: 'Metrobolsa no aplicada', proceso: 'R-METRO' },
      { id: 'MTR2', valor: 'Error al comprar Metrobolsa', proceso: 'R-METRO' },
      { id: 'MTR1', valor: 'No se puede acceder a comprar Metrobolsa', proceso: 'R-METRO' },
      { id: 'MTR5', valor: 'Traslado de Metrobolsa no realizado', proceso: 'R-METRO' },
      { id: 'MTR6', valor: 'Campaña referido', proceso: 'R-METRO' },
      { id: 'PYD5', valor: 'Empalme - Retiro y/o Traslado pendiente', proceso: 'R-DOMIC' },
      { id: 'PYD3', valor: 'Demora ejecución de trabajos', proceso: 'R-DOMIC' },
      { id: 'PYD4', valor: 'Cobro no corresponde/Devolución pendiente', proceso: 'R-DOMIC' },
      { id: 'PYD2', valor: 'Trabajo incompleto', proceso: 'R-DOMIC' },
      { id: 'PYD9', valor: 'Presupuesto pendiente/disconforme con ppto.', proceso: 'R-DOMIC' },
      { id: 'PYD6', valor: 'Reclamo contra personal', proceso: 'R-DOMIC' },
      { id: 'PYD8', valor: 'Traslado de medidor pendiente', proceso: 'R-DOMIC' },
      { id: 'REC7', valor: 'Problemas pago PAC/PAT', proceso: 'R-HRECAU' },
      { id: 'REC6', valor: 'Problema al pagar por www.metrogas.cl', proceso: 'R-HRECAU' },
      { id: 'REC8', valor: 'Problema al pagar por otros sitios web', proceso: 'R-HRECAU' },
      { id: 'REC1', valor: 'Problema al pagar por recaudadores externos presencial', proceso: 'R-HRECAU' },
      { id: 'PAVE', valor: 'Problema al pagar en cajas Metrogas', proceso: 'R-HRECAU' },
      { id: 'BOGA', valor: 'Boleta no llega', proceso: 'R-GRPART' },
      { id: 'REP1', valor: 'Boleta electrónica no enviada', proceso: 'R-GRPART' },
      { id: 'REP4', valor: 'Revocación de boleta electrónica', proceso: 'R-GRPART' },
      { id: 'PERE', valor: 'Reclamo a personal de reparto', proceso: 'R-GRPART' },
      { id: 'REP3', valor: 'Suscripción a boleta electrónica', proceso: 'R-GRPART' },
      { id: 'SRV2', valor: 'Dar de baja Servigas', proceso: 'R-SERVI' },
      { id: 'SRV6', valor: 'Reclamo contra personal', proceso: 'R-SERVI' },
      { id: 'SRV7', valor: 'Presupuesto', proceso: 'R-SERVI' },
      { id: 'SRV5', valor: 'Calidad del trabajo', proceso: 'R-SERVI' },
      { id: 'SRV4', valor: 'Trabajo incompleto', proceso: 'R-SERVI' },
      { id: 'SRV3', valor: 'Valor de la cuota', proceso: 'R-SERVI' },
      { id: 'SRV1', valor: 'Contratación', proceso: 'R-SERVI' },
      { id: 'WEB1', valor: 'Problema para registrarse', proceso: 'R-LSITIO' },
      { id: 'WEB2', valor: 'Error al ingresar a Centro de Ayuda', proceso: 'R-LSITIO' },
      { id: 'WEB3', valor: 'Error al modificar registro web', proceso: 'R-LSITIO' },
      { id: 'WEB6', valor: 'Error al intentar realizar pago', proceso: 'R-LSITIO' },
      { id: 'WEB7', valor: 'Problemas para recuperar clave', proceso: 'R-LSITIO' },
      { id: 'ART3', valor: 'Venta', proceso: 'R-ARTEFA' },
      { id: 'ART1', valor: 'Demora en envio de producto', proceso: 'R-ARTEFA' },
      { id: 'ART5', valor: 'Reclamo contra personal', proceso: 'R-ARTEFA' },
      { id: 'VTC5', valor: 'Demora en la conexión', proceso: 'R-VENTA2' },
      { id: 'VTC4', valor: 'Giftcard/Plan conexión no aplicado', proceso: 'R-VENTA2' },
      { id: 'VTC6', valor: 'Propiedad no factible de conectar', proceso: 'R-VENTA2' },
      { id: 'VTC1', valor: 'Contacto para contratación pendiente', proceso: 'R-VENTA2' },
      { id: 'VTC9', valor: 'Instalación llave angular no realizada', proceso: 'R-VENTA2' },
      { id: 'VTC8', valor: 'Retiro de empalme en dirección no conectada', proceso: 'R-VENTA2' }
    ];
  }

  onProcesoChange(event: any) {
    const selectedProceso = event ? event.id : null;
    this.procesoSeleccionado = !!selectedProceso;

    if (this.procesoSeleccionado) {
      this.filteredDataSubProceso = this.dataSubProceso.filter((subProceso: any) =>
        subProceso.proceso === selectedProceso
      );
    } else {
      this.filteredDataSubProceso = [];
    }
    this.formData.controls['subproceso'].setValue(null);
    this.verificarMostrarReclamoCobro();
  }

  onSubprocesoChange(event: any) {
    // Al cambiar el subproceso, re-aplicar la validación del monto si corresponde
    if (this.esReclamoPorCobro) {
      this.aplicarValidacionMontoSegunMotivo();
    }
  }

  verificarMostrarReclamoCobro() {
    const tipoContactoControl = this.formData.get('tipoContacto');
    
    const tipoContacto = tipoContactoControl ? tipoContactoControl.value : null;
    
    // La sección se muestra siempre que el tipo de contacto sea Reclamo
    const esReclamo = tipoContacto === 'reclamo';
    
    const anteriorMostrar = this.mostrarCheckboxReclamoCobro;
    this.mostrarCheckboxReclamoCobro = esReclamo;

    // Manejar validador requerido para esReclamoPorCobro según visibilidad
    const esReclamoCobroControl = this.formData.get('esReclamoPorCobro');
    if (this.mostrarCheckboxReclamoCobro) {
      esReclamoCobroControl?.setValidators([Validators.required]);
      // Pre-seleccionar valores por defecto al activarse la sección
      if (!anteriorMostrar) {
        this.formData.patchValue({
          esReclamoPorCobro: true,
          medioEnvioRespuesta: 'E'   // Correo electrónico seleccionado por defecto
        });
        this.onReclamoPorCobroChange(true);
        this.onMedioEnvioChange({ id: 'E' });  // activar lógica de dirección postal
      }
    } else {
      esReclamoCobroControl?.clearValidators();
    }
    esReclamoCobroControl?.updateValueAndValidity();

    // Manejar validadores de medioEnvioRespuesta según el tipo de contacto
    const medioEnvioControl = this.formData.get('medioEnvioRespuesta');
    if (!esReclamo) {
      // Si NO es reclamo, quitar la validación y limpiar el campo
      if (medioEnvioControl) {
        medioEnvioControl.clearValidators();
        medioEnvioControl.setValue(null);
        medioEnvioControl.updateValueAndValidity();
      }
      // Resetear también la dirección postal
      this.mostrarDireccionPostal = false;
      const direccionControl = this.formData.get('direccionPostal');
      direccionControl?.clearValidators();
      direccionControl?.setValue('');
      direccionControl?.updateValueAndValidity();
    } else {
      // Si ES reclamo, asegurarse que el campo es requerido
      if (medioEnvioControl) {
        medioEnvioControl.setValidators([Validators.required]);
        medioEnvioControl.updateValueAndValidity();
      }
    }
    
    // Si se oculta la sección, limpiar los valores relacionados
    if (!this.mostrarCheckboxReclamoCobro) {
      this.formData.patchValue({
        esReclamoPorCobro: null,
        montoReclamado: '',
        conceptoCobro: null,
        otroConceptoCobro: ''
      });
      this.esReclamoPorCobro = false;
      this.mostrarOtroConcepto = false;
      // Limpiar validadores cuando se oculta la sección
      const montoControl = this.formData.get('montoReclamado');
      const conceptoControl = this.formData.get('conceptoCobro');
      const otroConceptoControl = this.formData.get('otroConceptoCobro');
      montoControl?.clearValidators();
      montoControl?.updateValueAndValidity();
      conceptoControl?.clearValidators();
      conceptoControl?.updateValueAndValidity();
      otroConceptoControl?.clearValidators();
      otroConceptoControl?.updateValueAndValidity();
    }
  }

  sendEmail(nombre: string, mail: string, requestId: string) {
    this.apiService.sendEmail(nombre, mail, requestId).subscribe(
      response => {
      },
      error => {
        console.error('Error enviando email', error);
      }
    );
  }

  onSuscripcionChange(event: any) {
    let clientId = this.formData.value.nCliente;
    if (clientId === "") {
      alert('Es necesario ingresar su número de cliente.');
      this.formData.patchValue({
        suscripcion: false
      });
    } else {
      this.apiService.ConsultaSuscripcionBoletaElectronicaIC(clientId).subscribe((response: any) => {
        if (response.Indicador == "NO" || response.TipoTarifa == "Null") {
          this.formData.patchValue({
            suscripcion: false
          });
          const suscripcionControl = this.formData.get('suscripcion');
          if (suscripcionControl) suscripcionControl.disable();
          alert('Estimado cliente, la suscripción electrónica no es factible para este número de cliente.');
        }
      });
    }
  }

  getTextClass() {
    const suscripcionControl = this.formData.get('suscripcion');
    return { 'disabled-text': suscripcionControl ? suscripcionControl.disabled : false };
  }

  getCheckboxClass() {
    const suscripcionControl = this.formData.get('suscripcion');
    return { 'disabled-checkbox': suscripcionControl ? suscripcionControl.disabled : false };
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  validarNumeroCliente(control: AbstractControl): Observable<{ [key: string]: any } | null> {
    if (control.value === null || control.value.length === 0) {
      return of(null);
    } else {
      this.spinner.show();
      return timer(0).pipe(
        switchMap(() => {
          return this.apiService.checkCliente(control.value).pipe(
            map(res => {
              if (res.respuesta) {
                const nombreCiudad = res.ConsultarDireccionClientePorCtaCtoResponse?.Ciudad || '';
                this.actualizarConceptosCobro(nombreCiudad);
                this.spinner.hide();
                return null;
              } else {
                this.lightboxDiv('.modal-error-cliente');
              }
              this.spinner.hide();
              return { numClienteExist: true };
            })
          );
        })
      );
    }
  }

  getUserIp(): void {
  fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
      this.userIp = data.ip;
    })
    .catch(error => {
      this.userIp = '';
    });
  }

  generarDataConceptoCobro() {
    return this.generarDataConceptoCobroMTGS();
  }

  actualizarConceptosCobro(nombreCiudad: string) {
    const ciudadNorm = (nombreCiudad || '').toUpperCase().trim();
    const esGS00 = this.CIUDADES_GS00.some(c => ciudadNorm === c);
    this.dataConceptoCobro = esGS00
      ? this.generarDataConceptoCobroGS00()
      : this.generarDataConceptoCobroMTGS();
    this.formData.patchValue({ conceptoCobro: null });
    this.mostrarOtroConcepto = false;
  }

  generarDataConceptoCobroGS00() {
    return [
      { id: '51', valor: 'Cobro PH' },
      { id: '52', valor: 'Cobro Corte y Reposición' },
      { id: '53', valor: 'Consumo de Gas' },
      { id: '54', valor: 'Cuota Plan de Pago' },
      { id: '55', valor: 'Cuota Recuperación de Consumo' },
      { id: '56', valor: 'Cuota Reliquidación de Consumo' },    
      { id: '57', valor: 'Gastos de Cobranza' },
      { id: '58', valor: 'Interés' },
      { id: '59', valor: 'Retiro Medidor ' },
      { id: '60', valor: 'Retiro Reconexión Del Medidor' },
      { id: '99', valor: 'Otros(*)' }
    ];
  }

  generarDataConceptoCobroMTGS() {
    return [
      { id: '01', valor: 'Cobro PH' },
      { id: '02', valor: 'Consumo de Gas' },
      { id: '03', valor: 'Corte y Reposición' },
      { id: '04', valor: 'Cuota Artefacto' },
      { id: '05', valor: 'Cuota Recuperación de Consumo' },
      { id: '06', valor: 'Cuota Reliquidación de Consumo' },
      { id: '07', valor: 'Cuota Servigas' },
      { id: '08', valor: 'Gastos de Cobranza' },
      { id: '09', valor: 'Interés' },
      { id: '10', valor: 'Retiro Empalme' },
      { id: '11', valor: 'Retiro Medidor' },
      { id: '99', valor: 'Otros(*)' }
    ];
  }


  generarDataMedioEnvio() {
    return [
      { id: 'E', valor: 'Correo electrónico' },
      { id: 'P', valor: 'Correo postal' }
    ];
  }

  onReclamoPorCobroChange(value: boolean) {
    this.esReclamoPorCobro = value === true;
    const montoControl = this.formData.get('montoReclamado');
    const conceptoControl = this.formData.get('conceptoCobro');
    const otroConceptoControl = this.formData.get('otroConceptoCobro');

    if (value === true) {
      // Monto reclamado siempre obligatorio al seleccionar Sí
      if (montoControl) {
        montoControl.setValidators([Validators.required]);
      }
      // Concepto de cobro siempre obligatorio al seleccionar Sí
      if (conceptoControl) {
        conceptoControl.setValidators([Validators.required]);
        conceptoControl.setValue(null);
      }
    } else {
      // Si se selecciona "No" o se limpia, quitar las validaciones y limpiar los campos
      if (montoControl) {
        montoControl.clearValidators();
        montoControl.setValue('');
      }
      if (conceptoControl) {
        conceptoControl.clearValidators();
        conceptoControl.setValue(null);
      }
      if (otroConceptoControl) {
        otroConceptoControl.clearValidators();
        otroConceptoControl.setValue('');
      }
      this.mostrarOtroConcepto = false;
    }

    if (montoControl) montoControl.updateValueAndValidity();
    if (conceptoControl) conceptoControl.updateValueAndValidity();
    if (otroConceptoControl) otroConceptoControl.updateValueAndValidity();
  }

  aplicarValidacionMontoSegunMotivo() {
    const subprocesoControl = this.formData.get('subproceso');
    const montoControl = this.formData.get('montoReclamado');
    
    if (!montoControl || !subprocesoControl) return;
    
    const subproceso = subprocesoControl.value;
    const subprocesoValor = subproceso ? (typeof subproceso === 'object' ? subproceso.valor : subproceso) : null;
    
    // Motivos que requieren validación de monto si se ingresa
    const motivosConValidacionMonto = [
      'Consumo excesivo',
      'Facturación pendiente o atrasada',
      'Análisis de cuenta CT',
      'Consumo excesivo CT'
    ];
    
    // Motivos donde el monto puede ser nulo o 0 (ej: Peligro en la vía pública)
    const motivosSinValidacionMonto = [
      'Reclamo contra personal',
      'Demora',
      'Trabajo incompleto',
      'Reposiciones pendientes'
    ];
    
    // Verificar si el subproceso requiere validación de monto
    const requiereValidacionMonto = motivosConValidacionMonto.some(motivo => 
      subprocesoValor && subprocesoValor.toLowerCase().includes(motivo.toLowerCase())
    );
    
    if (requiereValidacionMonto) {
      // Para motivos de cobro excesivo o facturación: el campo es obligatorio y debe ser mayor a 0
      montoControl.setValidators([Validators.required, Validators.min(1)]);
    } else {
      // Para otros motivos: el monto es opcional, puede ser 0 o nulo
      montoControl.clearValidators();
    }
    
    montoControl.updateValueAndValidity();
  }

  onConceptoCobroChange(value: any) {
    const selectedValue = value ? value.id || value : null;
    this.mostrarOtroConcepto = selectedValue === '99';
    const otroConceptoControl = this.formData.get('otroConceptoCobro');

    if (otroConceptoControl) {
      if (this.mostrarOtroConcepto && this.esReclamoPorCobro) {
        otroConceptoControl.setValidators([Validators.required, Validators.maxLength(200)]);
      } else {
        otroConceptoControl.clearValidators();
        otroConceptoControl.setValue('');
      }
      otroConceptoControl.updateValueAndValidity();
    }
  }

  formatearMonto(event: any) {
    const input = event.target;
    let valor = input.value;
    
    // Remover todo excepto números
    valor = valor.replace(/\D/g, '');
    
    // Si está vacío, dejar el campo vacío
    if (valor === '') {
      this.formData.patchValue({ montoReclamado: '' }, { emitEvent: false });
      return;
    }
    
    // Si es solo ceros, limpiar
    if (parseInt(valor) === 0) {
      input.value = '';
      this.formData.patchValue({ montoReclamado: '' }, { emitEvent: false });
      return;
    }
    
    // Convertir a número entero
    const numeroEntero = parseInt(valor);
    
    // Formatear con separador de miles (punto)
    const numeroFormateado = numeroEntero.toLocaleString('es-CL');
    
    // Guardar posición del cursor antes de actualizar
    const posicionCursor = input.selectionStart || 0;
    const puntosAntes = (input.value.substring(0, posicionCursor).match(/\./g) || []).length;
    
    // Actualizar el valor formateado en el FormControl
    this.formData.patchValue({ montoReclamado: numeroFormateado }, { emitEvent: false });
    
    // Calcular nueva posición del cursor después del formateo
    setTimeout(() => {
      const puntosDespues = (numeroFormateado.substring(0, posicionCursor).match(/\./g) || []).length;
      const diferenciaPuntos = puntosDespues - puntosAntes;
      const nuevaPosicion = posicionCursor + diferenciaPuntos;
      input.setSelectionRange(nuevaPosicion, nuevaPosicion);
    }, 0);
  }

  agregarSeparadorMiles(valor: string): string {
    // Agregar separador de miles con punto
    return valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  removerSeparadorMiles(valor: string): string {
    // Remover puntos (separadores de miles)
    return valor.replace(/\./g, '');
  }

  detectarMencionComprobantes(texto: string): boolean {
    if (!texto || texto.trim() === '') {
      return false;
    }

    const textoLower = texto.toLowerCase();
    const palabrasClave = [
      'comprobante', 'comprobantes',
      'documento', 'documentos',
      'archivo', 'archivos',
      'adjunto', 'adjuntos',
      'respaldo', 'respaldos',
      'boleta', 'boletas',
      'factura', 'facturas',
      'recibo', 'recibos',
      'pago', 'pagos',
      'evidencia', 'evidencias',
      'prueba', 'pruebas',
      'certificado', 'certificados',
      'voucher', 'vouchers'
    ];

    return palabrasClave.some(palabra => textoLower.includes(palabra));
  }

  dismissAvisoComprobantes() {
    this.avisoComprobantesDismissed = true;
  }

  // Verifica si la descripción del documento en 'index' ya existe en otro documento
  descripcionDuplicada(index: number): boolean {
    const detalleActual = this.documentosAdjuntos[index]?.detalle?.trim().toLowerCase();
    if (!detalleActual || detalleActual === '') return false;

    return this.documentosAdjuntos.some((doc, i) =>
      i !== index &&
      doc.detalle?.trim().toLowerCase() === detalleActual
    );
  }

  // Retorna true si existe al menos un par de documentos con la misma descripción
  hayDescripcionesDuplicadas(): boolean {
    return this.documentosAdjuntos.some((_, i) => this.descripcionDuplicada(i));
  }

  onMedioEnvioChange(value: any) {
    const selectedValue = value ? value.id || value : null;
    this.mostrarDireccionPostal = selectedValue === 'P';
    
    const direccionControl = this.formData.get('direccionPostal');

    if (this.mostrarDireccionPostal) {
      // Si selecciona correo postal, el campo de dirección es obligatorio
      direccionControl?.setValidators([Validators.required, Validators.maxLength(300)]);
    } else {
      // Si selecciona correo electrónico, se quitan las validaciones
      direccionControl?.clearValidators();
      direccionControl?.setValue('');
    }

    direccionControl?.updateValueAndValidity();
  }
}
